import React from 'react'
import { MapTypeContext } from 'common/Map/MapTypeContext'
import { GoogleDivOverlay } from './GoogleDivOverlay'
import { LeafletDivOverlay } from './LeafletDivOverlay'
import { MapboxDivOverlay } from './MapboxDivOverlay'

export class DivOverlay extends React.PureComponent {
  static defaultProps = {
    interactive: false,
    pane: 'tooltipPane'
  }

  render () {
    const { position, zIndex, children, offset, interactive, pane, animatePosition, autoPan } = this.props
    return <MapTypeContext.Consumer>
      {({ mapType, mapInstance }) => {
        switch (mapType) {
          case 'leaflet':
            return <LeafletDivOverlay
              autoPan={autoPan}
              offset={offset}
              interactive={interactive}
              position={position}
              animatePosition={animatePosition}
              mapInstance={mapInstance}
              pane={pane}
              children={children} />
          case 'google':
            return <GoogleDivOverlay
              autoPan={autoPan}
              offset={offset}
              interactive={interactive}
              position={position}
              pane={pane}
              mapInstance={mapInstance}
              children={children} />
          case 'mapbox':
            return <MapboxDivOverlay
              autoPan={autoPan}
              offset={offset}
              interactive={interactive}
              position={position}
              zIndex={zIndex}
              pane={pane}
              mapInstance={mapInstance}
              children={children} />
          default:
            console.warn(`DivOverlay rendered with unknown mapType '${mapType}'`)
            return null
        }
      }}
    </MapTypeContext.Consumer>
  }
}
